import PropTypes from 'prop-types';
// https://github.com/bvaughn/react-error-boundary
import { ErrorBoundary } from 'react-error-boundary';

const Fallback = ({ error, resetErrorBoundary }) => (
  <div role='alert'>
    <p>Something went wrong:</p>
    <pre>{error.message}</pre>
    <button onClick={resetErrorBoundary}>Try again</button>
  </div>
);

Fallback.propTypes = {
  error: PropTypes.object.isRequired,
  resetErrorBoundary: PropTypes.func.isRequired,
};

const ReactErrorBoundary = ({
  children,
  environment = 'production',
  FallbackComponent = Fallback,
  onReset = details => details,
  logError = (error, info) => ({ error, info }),
} = {}) => {
  const handleLogError = (error, info) => {
    if (environment === 'development') {
      console.error(error, info);
    }
    return logError(error, info);
  };
  return (
    <ErrorBoundary FallbackComponent={FallbackComponent} onReset={onReset} onError={handleLogError}>
      {children}
    </ErrorBoundary>
  );
};

ReactErrorBoundary.propTypes = {
  children: PropTypes.node,
  environment: PropTypes.string,
  FallbackComponent: PropTypes.elementType,
  onReset: PropTypes.func,
  logError: PropTypes.func,
};

export default ReactErrorBoundary;
